import { TThunk } from 'shared/common/types/thunk';
import { setStatus } from 'shared/createCard/slices';
import { EEditStatus } from 'shared/createCard/types/editStatus';

export const setEditStatus =
  (status: EEditStatus): TThunk =>
  dispatch => {
    dispatch(setStatus(status));
  };
